import { memo, useEffect, useState, forwardRef, useImperativeHandle, useCallback } from 'react'
import classnames from 'classnames'
import moment from 'moment-timezone'
import './AlertsSection.scss'
import { useDispatch, useSelector } from 'react-redux'
import { ChartSection } from '../chart-section/ChartSection'
import { NewAlertForm } from '../new-alert-form/NewAlertForm'
import alertIcon from '../../../../images/charts/Alert.png'
import {
  ALERTS_TEXT,
  ARE_YOU_SURE_DELETE_ALERT_TEXT,
  DELETE_ALERT_TEXT,
  NO_ALERTS_TEXT,
} from '../../../../utils/constants'
import { AlertCard } from '../alert-card/AlertCard'
import {
  addAlert,
  getAlertsList,
  markAlertsAsRead,
  deleteAlert,
  editAlert as editAlertCall,
} from '../../../../store/charts/ChartsThunk'
import { setIsAlertAddedSuccess, setIsAlertsLoadedSuccess } from '../../../../store/charts/ChartsActions'
import { DeleteAlertPopUp } from '../delete-alert-popup/DeleteAlertPopUp'
import { compareArray } from '../../Utils'

const classes = {
  chartSection: 'alert-section-wrapper',
  chartSectionWithNewAlerForm: 'alert-section-wrapper-with-new-alert-form',
  chartSectionSmaller: 'alerts-section--smaller',
  chartSectionSmallerEmpty: 'alerts-section--smaller-empty',
  chartSectionSmallerWithNewAlerForm: 'alert-section-wrapper-with-new-alert-form--smaller',
}

export const AlertsSection = memo(
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  forwardRef(({ id, isMergedAccount = false, isSideCollapsed, userTimeZone }, ref) => {
    const dispatch = useDispatch()

    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
    const patientInfo = useSelector((state) => state.chartsReducer.patientInfo)
    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
    const isAlertAddedSuccess = useSelector((state) => state.chartsReducer.isAlertAddedSuccess)
    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
    const isPatientInfoLoadedSuccess = useSelector((state) => state.chartsReducer.isPatientInfoLoadedSuccess)
    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
    const isAlertsLoadedSuccess = useSelector((state) => state.chartsReducer.isAlertsLoadedSuccess)
    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
    const alerts = useSelector((state) => state.chartsReducer?.patientInfo?.[id]?.Alerts, compareArray)

    const currentPatientInfo = patientInfo?.[id]

    const [sortedAlerts, setSortedAlerts] = useState([])
    const [lastUpdateDateTimeValue, setLastUpdateDateTimeValue] = useState(
      currentPatientInfo?.AlertSummary?.LastUpdateDateTime,
    )
    const [newAlertValue, setNewAlertValue] = useState('')
    const [editAlertId, setEditAlertId] = useState(null)
    const [editAlert, setEditAlert] = useState(null)
    const [isVisibleToAll, setIsVisibleToAll] = useState(true)
    const [isCollapsed, setIsCollapsed] = useState(true)
    const [isNeedToAutoexpandSection, setIsNeedToAutoexpandSection] = useState(true)
    const [isOpenNewAlertForm, setIsOpenNewAlertForm] = useState(false)
    const [isMarkedAsRead, setIsMarkedAsRead] = useState(false)
    const [deleteAlertId, setDeleteAlertId] = useState('')
    const [initialAlertsCount, setInitialAlertsCount] = useState(0)

    useImperativeHandle(ref, () => ({
      closeAlertForm() {
        setIsOpenNewAlertForm(false)
        setEditAlert(null)
        setEditAlertId(null)
        setNewAlertValue('')
      },
    }))

    useEffect(() => {
      if (
        currentPatientInfo?.AlertSummary?.Count &&
        currentPatientInfo?.AlertSummary?.Count !== initialAlertsCount &&
        isPatientInfoLoadedSuccess
      ) {
        setInitialAlertsCount(currentPatientInfo?.AlertSummary?.Count)
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        dispatch(getAlertsList(id))
      }
    }, [isPatientInfoLoadedSuccess])

    useEffect(() => {
      if (alerts?.length) {
        // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
        const sortedAlerstList = alerts.sort((a, b) =>
          moment(a?.UpdateDateTime).isBefore(moment(b?.UpdateDateTime)) ? 1 : -1,
        )

        setLastUpdateDateTimeValue(sortedAlerstList[0].UpdateDateTime)
        setSortedAlerts(sortedAlerstList)
      } else {
        setSortedAlerts([])
      }
    }, [alerts])

    useEffect(() => {
      if (isAlertsLoadedSuccess) {
        if (isNeedToAutoexpandSection) {
          setIsCollapsed(false)
          setIsNeedToAutoexpandSection(false)
        }
        dispatch(setIsAlertsLoadedSuccess(false))
      }
    }, [isAlertsLoadedSuccess])

    useEffect(() => {
      if (isAlertAddedSuccess) {
        setIsOpenNewAlertForm(false)
        setNewAlertValue('')
        setIsVisibleToAll(true)
        // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
        dispatch(setIsAlertAddedSuccess())
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        dispatch(getAlertsList(id))
      }
    }, [isAlertAddedSuccess])

    useEffect(() => {
      if (!isCollapsed && !isMarkedAsRead && currentPatientInfo?.AlertSummary?.HasUnread) {
        setIsMarkedAsRead(true)
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        dispatch(markAlertsAsRead(id))
      }
    }, [isCollapsed])

    useEffect(() => {
      if (editAlertId) {
        // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
        const alertForEdit = currentPatientInfo.Alerts.find(({ AlertId }) => AlertId === editAlertId)

        setEditAlert(alertForEdit)
      }
    }, [editAlertId])

    useEffect(() => {
      if (editAlert) {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        setNewAlertValue(editAlert.Message)
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        setIsVisibleToAll(!editAlert.IsPrivate)
        setIsOpenNewAlertForm(true)
      }
    }, [editAlert])

    useEffect(() => {
      if (!isOpenNewAlertForm && editAlert) {
        setEditAlert(null)
        setEditAlertId(null)
      }
    }, [isOpenNewAlertForm])

    const onClickNewAlertButton = () => {
      setIsOpenNewAlertForm(true)
      if (isCollapsed) {
        setIsCollapsed(false)
      }
    }

    const onCloseNewAlertForm = () => {
      setIsOpenNewAlertForm(false)
    }

    const onAddAlert = useCallback(
      // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
      ({ Message, IsPrivate }) => {
        dispatch(
          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          addAlert(id, {
            Message,
            IsPrivate,
          }),
        )
      },
      [dispatch],
    )
    const onEditAlert = useCallback(
      // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
      ({ alertId, Message, IsPrivate }) => {
        dispatch(
          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          editAlertCall(
            id,
            {
              Message,
              IsPrivate,
            },
            alertId,
          ),
        )
      },
      [dispatch],
    )
    const onDeleteAlertAction = useCallback(
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      (alertId) => {
        if (alertId) {
          // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
          dispatch(deleteAlert(id, deleteAlertId))
        }
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        setDeleteAlertId(null)
      },
      [dispatch, deleteAlertId],
    )

    return (
      <>
        {deleteAlertId ?
          <div className='alerts-section-delete-pop-up-container'>
            <DeleteAlertPopUp
              setPopUpOpened={onDeleteAlertAction}
              popUpBodyText={ARE_YOU_SURE_DELETE_ALERT_TEXT}
              popUpTitle={DELETE_ALERT_TEXT}
            />
          </div>
        : null}

        {/*
         // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered */}
        <ChartSection
          className={classnames('alerts-section-main-wrapper', {
            [classes.chartSection]: !isCollapsed,
            [classes.chartSectionSmaller]: !isCollapsed && sortedAlerts.length < 3,
            [classes.chartSectionSmallerEmpty]: !isCollapsed && !sortedAlerts.length,
            [classes.chartSectionWithNewAlerForm]: !isCollapsed && isOpenNewAlertForm,
            [classes.chartSectionSmallerWithNewAlerForm]: !isCollapsed && isOpenNewAlertForm && sortedAlerts.length < 3,
          })}
          title={ALERTS_TEXT}
          icon={alertIcon}
          iconAltText='alerts'
          setIsCollapsed={setIsCollapsed}
          isCollapsed={isCollapsed}
          lastUpdated={lastUpdateDateTimeValue}
          emptyText={NO_ALERTS_TEXT}
          isWithNewIndicator={currentPatientInfo?.AlertSummary?.HasUnread}
          clickButtonAction={onClickNewAlertButton}
          isShowButton={!isOpenNewAlertForm && !isMergedAccount}
          isShowEmptyContent={isOpenNewAlertForm ? false : !sortedAlerts.length}
          userTimeZone={userTimeZone}
          isShouldScrollUpContent
          isNewButton>
          {isOpenNewAlertForm ?
            <NewAlertForm
              // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
              isSideCollapsed={isSideCollapsed}
              onCloseAction={onCloseNewAlertForm}
              newAlertValue={newAlertValue}
              setNewAlertValue={setNewAlertValue}
              isVisibleToAll={isVisibleToAll}
              setIsVisibleToAll={setIsVisibleToAll}
              editAlertId={editAlertId}
              editAlertCallback={onEditAlert}
              addAlertCallback={onAddAlert}
            />
          : null}
          {sortedAlerts.length ?
            <div className='alert-section-content-wrapper'>
              {sortedAlerts.map(({ AlertId, Author, IsRead, Message, UpdateDateTime, IsEditAllowed }) => (
                <AlertCard
                  key={AlertId}
                  // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
                  id={AlertId}
                  author={Author}
                  dateTime={UpdateDateTime}
                  description={Message}
                  isRead={IsRead}
                  setDeleteAlertId={setDeleteAlertId}
                  setEditAlertId={setEditAlertId}
                  isEditAllowed={IsEditAllowed}
                  isFormOpened={isOpenNewAlertForm}
                  userTimeZone={userTimeZone}
                />
              ))}
            </div>
          : null}
        </ChartSection>
      </>
    )
  }),
)
